import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="page-shell internal-page">
      <section className="page-hero">
        <p className="section-kicker">Privacy Policy</p>
        <h1>How the campaign handles your information.</h1>
        <p>Effective date: March 1, 2025</p>
      </section>

      <section className="content-panel prose-panel">
        <h2>Introduction</h2>
        <p>
          Welcome to the official website of Brian Hodgers for Florida State Representative. Your
          privacy matters to us, and this policy explains how personal information may be collected,
          used, and protected when you interact with the site.
        </p>

        <h2>Information we collect</h2>
        <ul>
          <li>Personal information such as your name, email address, or phone number when you provide it.</li>
          <li>Browser and device information gathered through cookies, analytics tools, or hosting logs.</li>
          <li>Information submitted through contact forms, event registrations, or donation workflows.</li>
        </ul>

        <h2>How your information may be used</h2>
        <ul>
          <li>To communicate campaign updates, event information, or responses to your inquiries.</li>
          <li>To process donations or other campaign-related transactions through third-party providers.</li>
          <li>To understand site traffic and improve the website experience.</li>
          <li>To comply with legal, regulatory, or campaign-finance obligations.</li>
        </ul>

        <h2>Sharing your information</h2>
        <p>
          The campaign does not sell your personal information. Information may be shared only when
          necessary to process services, comply with legal requirements, or support campaign operations.
        </p>

        <h2>Text message communications</h2>
        <p>
          You agree to receive informational messages, account notifications, account updates, or
          donation request messages from the Brian Hodgers Campaign. Message frequency varies. Message
          and data rates may apply. For help, email us at{" "}
          <a href="mailto:brian@brianforflorida.com">brian@brianforflorida.com</a>. You can opt out at
          any time by replying STOP.
        </p>
        <p>
          The campaign does not sell, rent, or share mobile opt-in information or consent records with
          third parties for marketing or promotional purposes.
        </p>

        <h2>Cookies and tracking</h2>
        <p>
          Cookies and similar technologies may be used to improve site performance and measure traffic.
          You can manage cookie preferences through your browser settings.
        </p>

        <h2>Security measures</h2>
        <p>
          Reasonable safeguards are used to protect personal information, but no transmission or storage
          method can be guaranteed to be completely secure.
        </p>

        <h2>Your choices</h2>
        <ul>
          <li>You may opt out of campaign emails at any time.</li>
          <li>You may request access to the personal information the campaign holds about you.</li>
          <li>You may request corrections or deletion where appropriate and legally permitted.</li>
        </ul>

        <h2>Contact</h2>
        <p>
          Questions about this policy can be sent to <a href="mailto:brian@brianforflorida.com">brian@brianforflorida.com</a> or by phone at{" "}
          <a href="tel:3212094645">(321) 209-4645</a>.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
